// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"611":"958188ab","641":"63e5d894"}[chunkId] + ".chunk.js";
};